import { useDispatch } from "react-redux";
import { useMatch } from "react-router-dom";
import APP_URL, { LONG_NAME } from "../declaration/URL";
import { useEffect } from "react";
import {
  clearCompanyLogState,
  clearDownloadLogState,
  clearFeatureLogState
} from "../features/snc_admin/LogStatistic/utils/stores";

const useResetLogStatistic = () => {
  const dispatch = useDispatch();

  const matchLogStatisticRoute = useMatch(LONG_NAME(APP_URL.sncAdmin.logStatistic.root));

  useEffect(() => {
    if (matchLogStatisticRoute) return;

    dispatch(clearFeatureLogState());
    dispatch(clearCompanyLogState());
    dispatch(clearDownloadLogState());
  }, [dispatch, matchLogStatisticRoute]);
};

export default useResetLogStatistic;
